import React, { useState, useEffect, Fragment } from "react"
import { useDispatch } from "react-redux"
import { Typography, Box } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Formik, Form } from "formik"
import ReusableFormControl from "components/ReusableFormControl"
import ReusableFormControlSelect from "components/ReusableFormControlSelect"
import { getOrgFields } from "actions/organization"
// import { openSnackBar } from "actions/snack-bar"

const AdditionalInfo = ({ updateRegData, regData, classes, formRef }) => {
  const dispatch = useDispatch()
  const [additionalFields, setAdditionalFields] = useState([])
  const [defaultValues, setDefaultValues] = useState({})

  useEffect(() => {
    dispatch(getOrgFields(regData.orgId))
      .then(res => {
        const fields = res.body.data
        const defaultValues = {}

        fields.map((field, index) => {
          const label = field.name
          const name = field.name.toLowerCase().replace(/\s/g, "")
          const options = field.options ? field.options.split(",") : null
          fields[index].label = label
          fields[index].name = name
          fields[index].options = options
          fields[index].id = field.id
        })

        fields.map(field => {
          defaultValues[field] = ""
        })

        setDefaultValues(defaultValues)
        setAdditionalFields(fields)
      })
      .catch(error => {
        console.log(error)
        // dispatch(
        //   openSnackBar({ message: "Failed to get additional information" })
        // )
      })
  }, [])

  return (
    <Fragment>
      <Typography variant="h2" className={classes.additionalInfoTitle}>
        Additional Information
      </Typography>
      {/* <Typography className={classes.additionalInfoExplanation}>
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
      </Typography> */}
      <Formik
        innerRef={formRef}
        initialValues={defaultValues}
        onSubmit={values => {
          let submitData = {}

          additionalFields.map(field => {
            const name = field.name
            submitData[name] = { value: "", id: field.id }
          })

          Object.keys(values).map(key => {
            const match = additionalFields.find(field => field.name === key)
            submitData[key] = { value: values[key], id: match.id }
          })

          updateRegData({ additionalFields: submitData })
        }}
      >
        {formikProps => (
          <Form className={classes.form}>
            <Box className={classes.fields}>
              {additionalFields.map(field => (
                <Box key={field.name} className={classes.field}>
                  {field.options === null ? (
                    <ReusableFormControl
                      name={field.name}
                      label={field.label}
                      formikProps={formikProps}
                    />
                  ) : (
                    <ReusableFormControlSelect
                      name={field.name}
                      label={field.label}
                      formikProps={formikProps}
                      options={field.options}
                    />
                  )}
                </Box>
              ))}
            </Box>
          </Form>
        )}
      </Formik>
    </Fragment>
  )
}

export default withStyles(styles)(AdditionalInfo)



// WEBPACK FOOTER //
// ./src/pages/Register/components/AdditionalInfo/index.jsx